<section class="">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <form [formGroup]="createAnnouncementForm">
          <div class="row">
            <div class="col-12 tp-txtpg">
              <h3 class="mb-4">{{ announcementId ? 'View' : 'Create New' }} Announcement / Circular</h3>
            </div>
            <div class="col-12 py-3" *ngIf="announcementId">
              <h5>Entry ID : {{ announcementDetail?.displayId }}</h5>
            </div>
            <div class="col-12 col-md-12" *ngIf="!announcementId">
              <app-category-selector
                [module]="'NA'"
                (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
            </div>
            <div class="col-12 col-md-4">
              <div class="mb-4">
                <label for="heading" class="form-label">Heading <sup>*</sup></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="heading"
                  value=""
                  [ngClass]="{ 'is-invalid': f['heading'].errors && f['heading'].touched }"
                  required />
              </div>
              <app-validation
                field="heading"
                [form]="createAnnouncementForm"
                [error]="{
                  required: 'This is a mandatory field, Kindly add heading'
                }"></app-validation>
            </div>
            <div class="col-12 col-md-4">
              <app-company-selector
                [companyId]="this.announcementDetail?.companyReferenceId"
                [showCompanyGroup]="true"
                [showError]="showValidationErrors"
                (selectedCompany)="handleCompanySelectedValue($event)"></app-company-selector>
            </div>
            <div class="col-12 col-md-4">
              <div class="mb-3">
                <label for="categoryType" class="form-label">Type of Category <sup>*</sup></label>
                <select
                  class="form-select"
                  aria-label="Category Type Select"
                  formControlName="type"
                  required
                  [ngClass]="{
                    'is-invalid': f['type'].errors && f['type']?.touched
                  }"
                  (change)="onCategoryChange($event.target.value)">
                  <option [disabled]="true" value="">Select Category</option>
                  <option *ngFor="let category of categoryTypes" [value]="category">
                    {{ category }}
                  </option>
                </select>
              </div>
              <app-validation
                field="type"
                [form]="createAnnouncementForm"
                [error]="{
                  required: 'This is a mandatory field, Kindly select Category Type'
                }"></app-validation>
            </div>
            <div class="col-12">
              <div class="mb-4">
                <label for="content" class="form-label">Content <sup>*</sup></label>
                <div class="NgxEditor__Wrapper">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [colorPresets]="colorPresets">
                  </ngx-editor-menu>

                  <ngx-editor
                    [editor]="editor"
                    formControlName="description"
                    value=""
                    required
                    [ngClass]="{ 'is-invalid': f['description'].errors && f['description'].touched }">
                  </ngx-editor>
                </div>
                <app-validation
                  field="description"
                  [form]="createAnnouncementForm"
                  [error]="{
                    required: 'This is a mandatory field, Kindly add description',
                    minLength: 'Description should have minimum 5 characters.',
                    maxLength: 'Max 5000 characters allowed'
                  }"></app-validation>
              </div>
            </div>
            <div class="col-4">
              <div class="mb-4">
                <p class="form-label">Upload Attachment</p>
                <input
                  type="file"
                  class="form-control"
                  name="files"
                  [accept]="inputAccept"
                  (change)="handleFileInput($event.target.files)" />
              </div>
              <div *ngIf="showError" [ngStyle]="{ 'margin-top': '2px', color: 'red', 'font-size': '13px' }">
                {{ errorMsg }}
              </div>
              <app-attachment-list
                *ngIf="announcementDetail"
                [attachments]="announcementDetail?.documents"
                [companyEntityId]="announcementDetail?.companyEntityId"></app-attachment-list>
              <div
                class="col-8 clear-button mt-3 justify-content-start acceptedFormatDescription"
                [innerHTML]="acceptedFormatMsg"></div>
            </div>
            <div class="col-4" *ngIf="f?.[DISPLAY_FROM_DATETIME_CONTROL_NAME]">
              <div class="mb-4">
                <label for="disfor" class="form-label">Display From <sup>*</sup></label>
                <input
                  type="date"
                  class="form-control"
                  formControlName="displayFromDatetime"
                  [ngClass]="{ 'is-invalid': f['displayFromDatetime'].errors && f['displayFromDatetime'].touched }"
                  required
                  (change)="dateCheckFromAndTo()" />
              </div>
              <app-validation
                field="displayFromDatetime"
                [form]="createAnnouncementForm"
                [error]="{
                  required: 'This is a mandatory field, Kindly select from date'
                }"></app-validation>
            </div>
            <div class="col-4" *ngIf="f?.[DISPLAY_TO_DATETIME_CONTROL_NAME]">
              <div class="mb-4">
                <label for="distil" class="form-label">Display Till <sup>*</sup></label>
                <input
                  type="date"
                  class="form-control"
                  formControlName="displayToDatetime"
                  [ngClass]="{ 'is-invalid': f['displayToDatetime'].errors && f['displayToDatetime'].touched }"
                  required
                  (change)="dateCheckFromAndTo()" />
              </div>
              <app-validation
                field="displayToDatetime"
                [form]="createAnnouncementForm"
                [error]="{
                  required: 'This is a mandatory field, Kindly select till date'
                }"></app-validation>
            </div>
            <div class="col-12 d-flex justify-content-end acvtypglastbtn">
              <a><button type="button" class="btn" (click)="saveAndExit()">PUBLISH</button></a>
              <a><button type="button" class="btn-discard" (click)="exit()">EXIT</button></a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
